import { z } from 'zod';

export const AuditActionSchema = z.enum([
  'CREATE',
  'UPDATE',
  'DELETE',
  'IMPORT',
  'SUBMIT',
  'STATE_TRANSITION',
  'FORECAST_RUN',
  'CONFIG_CHANGE',
  'LOGIN',
  'LOGOUT',
]);
export type AuditAction = z.infer<typeof AuditActionSchema>;

export const AuditLogSchema = z.object({
  id: z.string(),
  actor: z.string(), // email or "system"
  action: AuditActionSchema,
  entity_type: z.string(), // "forecast_adjustment", "config", ...
  entity_id: z.string().nullable().default(null),
  summary: z.string(), // human readable VN
  payload: z.record(z.unknown()).default({}),
  created_at: z.string(),
});
export type AuditLog = z.infer<typeof AuditLogSchema>;
